<template>
  <div class="neworder ">
    <Header :msg="msg" />

    <div class="main ">
      <div class="content ">
        <h1>Thông tin đặt hàng</h1>
        <form @submit.prevent>
          <h4>MÃ CTV: (Không phải CTV thì bỏ qua)</h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            v-model="neworder.ctv_id"
          />
          <h4>
            HỌ VÀ TÊN
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.name"
          />
          <h4>
            ĐỊA CHỈ: số nhà, Đường, Tổ/xóm, Phường/xã, Quận/huyện, Tỉnh/TP
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.address"
          />
          <h4>
            SĐT 1 : số của mình hoặc Bố mẹ
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.phone_1"
          />
          <h4>SĐT 2: số Bố - Mẹ (nhận giúp khi không liên lạc được SĐT 1)</h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            v-model="neworder.phone_2"
          />

          <h4>
            TÊN FACEBOOK: xác nhận đơn hàng khi học sinh đi học không nghe ĐT
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.fb"
          />

          <h4>
            LINK FACEBOOK: Dùng để tìm và xác nhận đơn hàng khi không thể liên
            lạc được với khách hàng bằng SĐT
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.link"
          />

          <h4>EMAIL: Dùng để gửi tài liệu miễn phí cho học sinh</h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            v-model="neworder.email"
          />

          <h4>
            MÃ SÁCH IN - ĐẶT MUA: sau mã sách bắt buộc có chữ "i" đằng sau để
            phân biệt với sách photo
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            v-model="neworder.print"
          />

          <h4>
            MÃ SÁCH PHOTO - ĐẶT MUA:
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.photo"
          />

          <h4>MÃ SÁCH TẶNG THÊM:</h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            v-model="neworder.gift"
          />

          <h4>
            GHI CHÚ: CTV sử dụng để ghi số tiền nhà sách thu học sinh COD=(SÁCH+
            SHIP), phần chêch lệch trừ vào chiết khấu, lưu ý SHIP là cố định
            <span>*</span>
          </h4>
          <input
            type="text"
            placeholder="Điền thông tin vào đây"
            required
            v-model="neworder.note"
          />

          <div class="cntr">
            <button @click="createNewOrder()" class="btn-x">
              Tạo đơn
              <span class="arrow">&#10140;</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  },

  data() {
    return {
      msg: sessionStorage.getItem("role"),
      neworder: {
        ctv_id: "",
        id: "", // mã id tự sinh
        name: "",
        address: "",
        phone_1: "",
        phone_2: "",
        fb: "",
        link: "",
        email: "",
        print: "",
        photo: "",
        gift: "",
        note: "",
        date:
          ("0" + new Date().getDate()).slice(-2) +
          "/" +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          "/" +
          new Date().getFullYear(), // get ngày tháng năm
        homebook: "", // đọc sessionStorage
        owned: sessionStorage.getItem("id"), // đọc sessionStorage
        status: "no", // đọc sessionStorage
        role: sessionStorage.getItem("role"), // đọc sessionStorage
        ctv: sessionStorage.getItem("owned") // đọc sessionStorage
      }
    };
  },
  methods: {
    createNewOrder() {
      if ((this.neworder.note %1) != 0) {
        alert("Giá tiền nhập ở dạng số Ví dụ 100");
      } else if (
        this.neworder.name != "" &&
        this.neworder.address != "" &&
        this.neworder.phone_1 != "" &&
        this.neworder.fb != "" &&
        this.neworder.link != "" &&
        this.neworder.photo != "" &&
        this.neworder.note != ""
      ) {
        let sheet =
          "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders";

        // gender random order code

        this.neworder.id = "MA" + new Date().getTime();

        const data = [this.neworder];

        axios.post(sheet, this.neworder).then(response => {
          alert("Tạo đơn thành công");
          this.neworder = {
            ctv_id: "",
            id: "", // mã id tự sinh
            name: "",
            address: "",
            phone_1: "",
            phone_2: "",
            fb: "",
            link: "",
            email: "",
            print: "",
            photo: "",
            gift: "",
            note: "",
            date:
              ("0" + new Date().getDate()).slice(-2) +
              "/" +
              ("0" + (new Date().getMonth() + 1)).slice(-2) +
              "/" +
              new Date().getFullYear(), // get ngày tháng năm
            homebook: "", // đọc sessionStorage
            owned: sessionStorage.getItem("id"), // đọc sessionStorage
            status: "no", // đọc sessionStorage
            role: sessionStorage.getItem("role"), // đọc sessionStorage
            ctv: sessionStorage.getItem("owned") // đọc sessionStorage
          };
        });
      }
    }
  },
  beforeCreate(){
    // alert("Bạn có thể chỉnh sửa thông tin bằng cách chọn vào tên trên góc trái màn hình");
  }
};
</script>
<style lang="css" scoped>
.btn-x {
  border: none !important;
  font-size: 1em !important;
  margin-bottom: 3rem;
  margin-top: 2rem !important;
  border-radius: 5px !important;
  outline: none;
}
.arrow {
  float: right;
  background: transparent;
  color: white;
  display: block;
  padding-left: 0.5rem;
  transform: rotate(0deg);
}
button:hover {
  animation: scolls 0.4s linear 2;
}
@keyframes scolls {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(3deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
body {
  background-color: whitesmoke;
}
button {
  outline: none;
}
span {
  color: red;
}
.main {
  /* width: 80%; */
  margin: auto;
}
.logo {
  margin: 1rem;
  border-radius: 10px;
  overflow: hidden; /* border-bottom: 5px solid #34495e; */
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}
.logo img {
  width: 100%;
}
.content {
  position: relative;
  margin: 1rem;
  background-color: white;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  margin-top: 2rem;
}
.content input {
  width: 100%;
  background-color: rgba(240, 235, 220, 0.5);
  border: none;
  border-bottom: 4px solid rgba(240, 235, 220, 1);
  padding: 1rem;
  border-radius: 5px;
  margin-top: 1rem;
  outline-color: bisque;
}
.content input:focus {
  outline-color: antiquewhite;
  transition: 1s;
}
.content h4 {
  margin-top: 1rem;
}
.content h1 {
  text-align: center;
  margin-bottom: 2rem;
  background-color: #e74c3c;
  border-radius: 5px;
  display: block;
  padding: 1rem;
  color: white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}
.content button {
  background-color: #ff5252;
}
input,
button,
h4,
h1 {
  /* font-family: "Roboto", sans-serif; */
  color: rgb(50, 50, 50);
}
button {
  margin-top: 2rem;
  position: relative;
  background: #000;
  border: 0;
  padding: 14px 42px;
  border-radius: 3px;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  font-weight: 400;
  font-size: 12px;
  color: #fff;
  letter-spacing: 0.2em;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}
button:after {
  content: "";
  position: absolute;
  top: 0;
  left: -200%;
  width: 200%;
  height: 100%;
  transform: skewX(-20deg);
  background-image: linear-gradient(
    to right,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
}
button:hover:after {
  animation: shine 2s ease;
}
button:active {
  transform: translateY(1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
} /* .cntr { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); } */
@-moz-keyframes shine {
  100% {
    left: 200%;
  }
}
@-webkit-keyframes shine {
  100% {
    left: 200%;
  }
}
@-o-keyframes shine {
  100% {
    left: 200%;
  }
}
@keyframes shine {
  100% {
    left: 200%;
  }
}

@media screen and (min-width: 768px) {
  .content {
    width: 35rem;
    margin: auto;
    margin-top: 5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewOrder.vue